import { render, staticRenderFns } from "./DsfExamMarking.vue?vue&type=template&id=6f2ae404&"
import script from "./DsfExamMarking.vue?vue&type=script&lang=js&"
export * from "./DsfExamMarking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfExamMarking.vue"
export default component.exports